import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo1.png";
import styled from "styled-components";

const Header = (props) => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <HeaderMain>
      <Logo to="/">
        <img src={logo} alt="" />
      </Logo>
      <Navlist className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link to="/" className={props.active}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/pricing" className={props.active1}>
            Pricing
          </Link>
        </li>
        <li>
          <Link to="/support" className={props.active2}>
            Support
          </Link>
        </li>
        <li>
          <Link to="/contact-us" className={props.active3}>
            Contact Us
          </Link>
        </li>
      </Navlist>
      <Link to="/sign-up">
        <GetStarted>Sign Up</GetStarted>
      </Link>
    </HeaderMain>
  );
};

export default Header;

const HeaderMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 50px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Logo = styled(Link)`
  img {
    width: 200px;
    height: 70px;
    cursor: pointer;
  }
`;

const Navlist = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin-right: 70px;

  li {
    margin: 25px;
    a {
      text-decoration: none;
      color: grey;
      font-size: 17px;
      font-weight: 500;
    }
    .active {
      color: #20204f;
    }
  }

  @media only screen and (max-width: 991px) {
    .nav-menu {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 200vh;
      position: fixed;
      top: 0%;
      left: -100%;
      opacity: 1;
      transition: all 0.5s ease;
      overflow: hidden;
      padding-top: 25rem;
    }
    .nav-menu.active {
      background-color: #fff;
      left: 50%;
      opacity: 1;
      overflow: hidden;
      transition: all 0.5s ease;
    }
  }
`;

const GetStarted = styled.div`
  padding: 10px 30px;
  text-decoration: none;
  border-radius: 8px;
  background-color: #3aaa35;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
`;
